@if(isInit()) {
  <div class="d-flex flex-grow-1 flex-column my-5 align-content-center justify-content-center">
    <p-progress-spinner ariaLabel="loading" />
  </div>
} @else {
  @if((versions() && versions().length > 0) || router.url === '/cy/patient/ps/create') {
    <div class="columnify">

      <!-- Table of Contents -->
      <div
        #parentDiv
        class="table-column"
        (window:resize)="onResize($event, parentDiv, 'resize')"
        (window:scroll)="onResize($event, parentDiv, 'scroll')"
      >
        <ul
          #stickyContentsTable
          class="contents-table sticky"
        >
          <a>{{translations.patient_data}}</a>
          <li>
            <a [class.active]="activeSection === 'demographics'" (click)="goTo(demographics)">{{translations.demographics}}</a>
          </li>
          <li>
            <a class="d-inline-flex justify-content-between align-items-start" [class.active]="activeSection === 'contacts'" (click)="goTo(contacts)"><span>{{translations.contacts}}</span><span class="badge bg-secondary">{{entries().cp_counts}}</span></a>
          </li>
          <li>
            <a class="d-inline-flex justify-content-between align-items-start" [class.active]="activeSection === 'insurances'" (click)="goTo(insurances)"><span>{{translations.insurances}}</span><span class="badge bg-secondary">{{entries().insurance_counts}}</span></a>
          </li>
          <a>{{translations.clinical_data}}</a>
          <li>
            <a class="d-inline-flex justify-content-between align-items-start" [class.active]="activeSection === 'allergies'" (click)="goTo(allergies)"><span>{{translations.allergies}}</span><span class="badge bg-secondary">{{entries().allergies_counts}}</span></a>
          </li>
          <li>
            <a class="d-inline-flex justify-content-between align-items-start" [class.active]="activeSection === 'vaccinations'" (click)="goTo(vaccinations)"><span>{{translations.vaccinations}}</span><span class="badge bg-secondary">{{entries().vaccinations_counts}}</span></a>
          </li>
          <li>
            <a class="d-inline-flex justify-content-between align-items-start" [class.active]="activeSection === 'past_illness'" (click)="goTo(past_illness)"><span>{{translations.past_illness}}</span><span class="badge bg-secondary">{{entries().illness_counts}}</span></a>
          </li>
          <li>
            <a class="d-inline-flex justify-content-between align-items-start" [class.active]="activeSection === 'surgical_procedures'" (click)="goTo(surgical_procedures)"><span>{{translations.surgical_procedures}}</span><span class="badge bg-secondary">{{entries().surgical_procedures_counts}}</span></a>
          </li>
          <li>
            <a class="d-inline-flex justify-content-between align-items-start" [class.active]="activeSection === 'problems_diagnoses'" (click)="goTo(problems_diagnoses)"><span>{{translations.problems_diagnoses}}</span><span class="badge bg-secondary">{{entries().current_problems_counts}}</span></a>
          </li>
          <li>
            <a class="d-inline-flex justify-content-between align-items-start" [class.active]="activeSection === 'devices_implants'" (click)="goTo(devices_implants)"><span>{{translations.devices_implants}}</span><span class="badge bg-secondary">{{entries().medical_device_counts}}</span></a>
          </li>
          <li>
            <a class="d-inline-flex justify-content-between align-items-start" [class.active]="activeSection === 'treatments'" (click)="goTo(treatments)"><span>{{translations.treatments}}</span><span class="badge bg-secondary">{{entries().treatment_counts}}</span></a>
          </li>
          <li>
            <a class="d-inline-flex justify-content-between align-items-start" [class.active]="activeSection === 'autonomy_invalidity'" (click)="goTo(autonomy_invalidity)"><span>{{translations.autonomy_invalidity}}</span><span class="badge bg-secondary">{{entries().autonomy_counts}}</span></a>
          </li>
          <li>
            <a class="d-inline-flex justify-content-between align-items-start" [class.active]="activeSection === 'medication'" (click)="goTo(medication)"><span>{{translations.medication}}</span><span class="badge bg-secondary">{{entries().medication_counts}}</span></a>
          </li>
          <li>
            <a class="d-inline-flex justify-content-between align-items-start" [class.active]="activeSection === 'social_history'" (click)="goTo(social_history)"><span>{{translations.social_history}}</span><span class="badge bg-secondary">{{entries().social_counts}}</span></a>
          </li>
          <li>
            <a class="d-inline-flex justify-content-between align-items-start" [class.active]="activeSection === 'physical_findings'" (click)="goTo(physical_findings)"><span>{{translations.physical_findings}}</span><span class="badge bg-secondary">{{entries().vital_signs_counts}}</span></a>
          </li>
          <li>
            <a class="d-inline-flex justify-content-between align-items-start" [class.active]="activeSection === 'diagnostic_tests'" (click)="goTo(diagnostic_tests)"><span>{{translations.diagnostic_tests}}</span><span class="badge bg-secondary">{{entries().diagnostic_counts}}</span></a>
          </li>
          @if(patientService.data?.gender?.toLowerCase() === 'θηλυ') {
            <li>
              <a class="d-inline-flex justify-content-between align-items-start" [class.active]="activeSection === 'pregnancies'" (click)="goTo(pregnancies)"><span>{{translations.pregnancies}}</span><span class="badge bg-secondary">{{entries().pregancy_counts}}</span></a>
            </li>
          }
          <a>{{translations.versioning_data}}</a>
          <li>
            <a class="d-inline-flex justify-content-between align-items-start" [class.active]="activeSection === 'versions'" (click)="goTo(versions)"><span>{{translations.versions}}</span></a>
          </li>
        </ul>
      </div>

      <!-- Body -->
      <div class="d-flex flex-column overflow-x-hidden">
        <router-outlet id="buttonsSection"/>

        <div #content_demographics class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
          <div
            (window:scroll)="onScroll($event, demographics, content_demographics)"
            (window:scrollend)="onScroll($event, demographics, content_demographics)"
            #demographics id="demographics" class="demographics-table"
          ></div>
          <ncp-demographics />
        </div>

        <div #content_contacts class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
          <div
            (window:scroll)="onScroll($event, contacts, content_contacts)"
            (window:scrollend)="onScroll($event, contacts, content_contacts)"
            #contacts id="contacts" class="contacts-table"
          ></div>
          <ncp-contacts />
        </div>

        <div #content_insurances class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
          <div
            (window:scroll)="onScroll($event, insurances, content_insurances)"
            (window:scrollend)="onScroll($event, insurances, content_insurances)"
            #insurances id="insurances" class="insurances-table"
          ></div>
          <ncp-insurances />
        </div>

        <div #content_allergies class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
          <div
            (window:scroll)="onScroll($event, allergies, content_allergies)"
            (window:scrollend)="onScroll($event, allergies, content_allergies)"
            #allergies id="allergies" class="allergies-table"
          ></div>
          <ncp-allergies />
        </div>

        <div #content_vaccinations class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
          <div
            (window:scroll)="onScroll($event, vaccinations, content_vaccinations)"
            (window:scrollend)="onScroll($event, vaccinations, content_vaccinations)"
            #vaccinations id="vaccinations" class="vaccinations-table"
          ></div>
          <ncp-vaccinations />
        </div>

        <div #content_past_illness class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
          <div
            (window:scroll)="onScroll($event, past_illness, content_past_illness)"
            (window:scrollend)="onScroll($event, past_illness, content_past_illness)"
            #past_illness id="past_illness" class="past-illness-table"
          ></div>
          <ncp-past-illnesses />
        </div>

        <div #content_surgical_procedures class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
          <div
            (window:scroll)="onScroll($event, surgical_procedures, content_surgical_procedures)"
            (window:scrollend)="onScroll($event, surgical_procedures, content_surgical_procedures)"
            #surgical_procedures id="surgical_procedures" class="surgical-procedures-table"
          ></div>
          <ncp-surgical-procedures />
        </div>

        <div #content_problems_diagnoses class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
          <div
            (window:scroll)="onScroll($event, problems_diagnoses, content_problems_diagnoses)"
            (window:scrollend)="onScroll($event, problems_diagnoses, content_problems_diagnoses)"
            #problems_diagnoses id="problems_diagnoses" class="problems-diagnoses-table"
          ></div>
          <ncp-problems-diagnoses />
        </div>

        <div #content_devices_implants class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
          <div
            (window:scroll)="onScroll($event, devices_implants, content_devices_implants)"
            (window:scrollend)="onScroll($event, devices_implants, content_devices_implants)"
            #devices_implants id="devices_implants" class="devices-implants-table"
          ></div>
          <ncp-devices-implants />
        </div>

        <div #content_treatments class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
          <div
            (window:scroll)="onScroll($event, treatments, content_treatments)"
            (window:scrollend)="onScroll($event, treatments, content_treatments)"
            #treatments id="treatments" class="treatments-table"
          ></div>
          <ncp-treatments />
        </div>

        <div #content_autonomy_invalidity class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
          <div
            (window:scroll)="onScroll($event, autonomy_invalidity, content_autonomy_invalidity)"
            (window:scrollend)="onScroll($event, autonomy_invalidity, content_autonomy_invalidity)"
            #autonomy_invalidity id="autonomy_invalidity" class="autonomy-invalidity-table"
          ></div>
          <ncp-autonomy-invalidity />
        </div>

        <div #content_medication class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
          <div
            (window:scroll)="onScroll($event, medication, content_medication)"
            (window:scrollend)="onScroll($event, medication, content_medication)"
            #medication id="medication" class="treatments-table"
          ></div>
          <ncp-medication />
        </div>

        <div #content_social_history class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
          <div
            (window:scroll)="onScroll($event, social_history, content_social_history)"
            (window:scrollend)="onScroll($event, social_history, content_social_history)"
            #social_history id="social_history" class="social-history-table"
          ></div>
          <ncp-social-history />
        </div>

        <div #content_physical_findings class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
          <div
            (window:scroll)="onScroll($event, physical_findings, content_physical_findings)"
            (window:scrollend)="onScroll($event, physical_findings, content_physical_findings)"
            #physical_findings id="physical_findings" class="physical-findings-table"
          ></div>
          <ncp-physical-findings />
        </div>

        <div #content_diagnostic_tests class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
          <div
            (window:scroll)="onScroll($event, diagnostic_tests, content_diagnostic_tests)"
            (window:scrollend)="onScroll($event, diagnostic_tests, content_diagnostic_tests)"
            #diagnostic_tests id="diagnostic_tests" class="diagnostic-tests-table"
          ></div>
          <ncp-diagnostic-tests />
        </div>

        <div #content_pregnancies [class]="(patientService.data?.gender?.toLowerCase() === 'θηλυ') ? 'flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto' : ''">
          <div
            (window:scroll)="onScroll($event, pregnancies, content_pregnancies)"
            (window:scrollend)="onScroll($event, pregnancies, content_pregnancies)"
            #pregnancies id="pregnancies" class="pregnancies-table"
          ></div>
          @if(patientService.data?.gender?.toLowerCase() === 'θηλυ') {
            <ncp-pregnancies />
          }
        </div>

        <div #content_versions class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
          <div
            (window:scroll)="onScroll($event, versions, content_versions)"
            (window:scrollend)="onScroll($event, versions, content_versions)"
            #versions id="versions" class="versions-table"
          ></div>
          <ncp-versions />
        </div>

      </div>
    </div>
  } @else {
    <div class="">
      Please add consent message for creating a PS version for a new patient
      <ncp-button
        [(options)]="createButtonOptions"
      />
    </div>
  }
}
